import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UiService } from '../../../services/shared/ui.service';

@Component({
  selector: 'jenz-spinner',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Spinner {
  readonly ui = inject(UiService);
}
